'use strict';

import { View } from 'backbone';
import $ from 'jquery';
import cookies from 'js-cookie';
import config from '../../js/config';
import { userService } from '../../services/CartUserService';
import analytics from '../Analytics/Analytics';
import PromotionalGiveawayModal from './PromotionalGiveawayModal';
import $global from '../../js/globalElements';
import cacheCookieHelper from '../../components/CacheCookieHelper/CacheCookieHelper';

function daysInMonth(month, year) {
  return new Date(year, month, 0).getDate();
}

export default class PromotionalGiveawayRegistrationView extends View {

  constructor(options) {
    options.events = {
      'click .PromotionalGiveaway-registration-submitButton': 'submitData',
      'change select#PromotionalGiveaway-registration-countryInput': 'updateStates',
      'change select#PromotionalGiveaway-registration-dobMonthInput': 'updateDobDay',
      'change select#PromotionalGiveaway-registration-dobYearInput': 'updateDobDay'
    };
    super(options);
    this.apiUrl = config.promoGiveaway.apiUrl;
    this.$form = this.$el.find('form');
    this.configuration = this.$el.data('registrationConfiguration');
    this.$countriesDropdown = this.$el.find('#PromotionalGiveaway-registration-countryInput');
    this.$statesDropdown = this.$el.find('#PromotionalGiveaway-registration-stateInput');
    this.$dobDayDropdown = this.$el.find('#PromotionalGiveaway-registration-dobDayInput');
    this.$dobMonthDropdown = this.$el.find('#PromotionalGiveaway-registration-dobMonthInput');
    this.$dobYearDropdown = this.$el.find('#PromotionalGiveaway-registration-dobYearInput');
    this.initializeCountriesState();
    this.runValidationOnStartup();
    this.populateDobDayDropdown(30);
    this.getUserInfoPromise = this.getUserInfo();
  }

  runValidationOnStartup() {
    if (this.$el.find('#PromotionalGiveaway-registration-shouldRunFEValidation').length > 0) {
      this.$form.validate();
    }
  }

  initializeCountriesState() {
    this.$statesDropdown.find('option').each(function() {
      let $el = $(this);
      let value = $el.val();
      if (value) {
        let parts = value.split(' ');
        $el.attr('data-country', parts[0]);
        $el.val(parts[1]);
      }
    });
  }

  updateStates() {
    let selectedCountry = $('#PromotionalGiveaway-registration-countryInput option:selected')[0].value;
    this.$statesDropdown.removeAttr('disabled');
    this.$statesDropdown.find('option')[0].selected = true;
    this.$statesDropdown.find('option[data-country]').hide();
    this.$statesDropdown.find(`option[data-country=${selectedCountry}]`).show();
  }

  updateDobDay() {
    let year = this.$dobYearDropdown.val();
    let month = this.$dobMonthDropdown.val();
    if (month && year) {
      let daysNumber = daysInMonth(month, year);
      this.populateDobDayDropdown(daysNumber);
    }
  }

  populateDobDayDropdown(daysNumber) {
    this.$dobDayDropdown.find('option[value]').remove();
    for (let i = 1; i <= daysNumber; i++) {
      this.$dobDayDropdown.append($(`<option value="${i}">${i}</option>`));
    }
  }

  collectAndFormatFormData(userData) {
    let prepareRequestData = (userData, referralGuid, referralSource) => {
      let data = {Registration: {}, Extended: {}};

      data.Registration.FirstName = userData.firstName;
      data.Registration.LastName = userData.lastName;
      data.Registration.AgreeToRules = this.$el.find('#PromotionalGiveaway-registration-tosInput').is(':checked');
      data.Registration.OptIn = this.$el.find('#PromotionalGiveaway-registration-marketingBoxInput').is(':checked');
      data.Registration.Phone = this.$el.find('#PromotionalGiveaway-registration-phoneInput').val();
      data.Registration.Email = userData.email;
      data.Registration.ReferringUserGuid = referralGuid;
      data.Registration.Source = referralSource;
      data.Registration.Birthdate = this.$el.find('#PromotionalGiveaway-registration-dobYearInput').val()
        + '-' + this.$el.find('#PromotionalGiveaway-registration-dobMonthInput').val()
        + '-' + this.$el.find('#PromotionalGiveaway-registration-dobDayInput').val();
      data.Registration.Address = {
        Address1: this.$el.find('#PromotionalGiveaway-registration-addressInput').val(),
        City: this.$el.find('#PromotionalGiveaway-registration-cityInput').val(),
        PostalCode: this.$el.find('#PromotionalGiveaway-registration-zipcodeInput').val(),
        State: this.$el.find('#PromotionalGiveaway-registration-stateInput').val(),
        Country: this.$el.find('#PromotionalGiveaway-registration-countryInput').val()
      };
      data.Extended.JobFunction = this.$el.find('#PromotionalGiveaway-registration-jobFunctionInput').val();
      data.Extended.JobLevel = this.$el.find('#PromotionalGiveaway-registration-jobLevelInput').val();
      data.Extended.Industry = this.$el.find('#PromotionalGiveaway-registration-industryInput').val();
      data.Extended.Interests = this.$el.find('#PromotionalGiveaway-registration-interestsInput').val();
      data.Extended.Company = this.$el.find('#PromotionalGiveaway-registration-companyInput').val();

      return data;
    };

    return new Promise(resolve => {
      let referralInfo = cookies.get(config.cookies.promotionalGiveaway.referralGuidCookie);
      let referralPublicGuid = null;
      let referralSource = null;
      if (referralInfo) {
        let referralParts = referralInfo.split('|');
        referralPublicGuid = referralParts[0];
        referralSource = referralParts[1];
      }
      if (referralPublicGuid && referralPublicGuid.length > 0)
      {
        this.getGuid(referralPublicGuid)
          .then(guid => {
            let requestData = prepareRequestData(userData, guid, referralSource);
            resolve(requestData);
          })
          .fail(() => {
            let requestData = prepareRequestData(userData);
            resolve(requestData);
          })
      }
      else
      {
        let requestData = prepareRequestData(userData);
        resolve(requestData);
      }
    });
  }

  showModal(configuration) {
    configuration.singleCta = true;
    let modal = new PromotionalGiveawayModal();
    modal.open(configuration);
  }

  submitData() {
    this.$form.validate({
      rules: {
        'PromotionalGiveaway-registration-phoneInput': {
          digits: true
        },
        'Phone': {
          digits: true
        }
      },
      submitHandler: () => {
        this.getUserInfoPromise.then((userData) => {
          $global.$body.addClass(config.classes.loadingClass);
          this.createUser(userData);
        })
      }
    });
  }

  getUserInfo() {
    return userService
      .getUserInfo(true);
  }

  createUser(userData) {
    let _this = this;
    this.collectAndFormatFormData(userData).then(requestData => {
      let requestDataSerialized = JSON.stringify(requestData);
      $.ajax({
        type: 'POST',
        url: this.apiUrl + config.promoGiveaway.createUserPath,
        data: requestDataSerialized,
        contentType: 'application/json',
        processData: false
      })
        .done(data => {
          let userEmail = data.Email;
          Promise.all([
            _this.setUserPublicIdCookie(userEmail),
            _this.triggerConfirmationEmail(userEmail)
          ]).then(() => {
            this.pushAnalyticsEvent();
            _this.showModal({
              title: _this.configuration.completionModal.title,
              message: _this.configuration.completionModal.message,
              cta1Link: _this.configuration.completionModal.cta.link,
              cta1Text: _this.configuration.completionModal.cta.text
            });
          })
        })
        .fail(() => {
          $global.$body.removeClass(config.classes.loadingClass);
        })
    });
  }

  getGuid(publicIdentifier) {
    return $.ajax({
      type: 'GET',
      url: this.apiUrl + config.promoGiveaway.getGuidPath + encodeURIComponent(publicIdentifier),
      global: false
    })
  }

  setUserPublicIdCookie(userEmail) {
    return $.ajax({
      type: 'GET',
      url: this.apiUrl + config.promoGiveaway.getPublicUserIdPath + encodeURIComponent(userEmail)
    })
      .done(data => {
        let userPublicId = data.Id;
        cookies.set(
          config.cookies.promotionalGiveaway.userGuidCookie,
          userPublicId,
          { expires: config.cookies.promotionalGiveaway.userGuidCookieExpiration });

        if (cacheCookieHelper) {
          cacheCookieHelper.setCacheCookie();
        }
      })
  }

  triggerConfirmationEmail(userEmail) {
    return $.ajax({
      type: 'GET',
      url: this.apiUrl + config.promoGiveaway.triggerConfirmationEmailPath + encodeURIComponent(userEmail),
      dataType: 'text'
    })
  }

  pushAnalyticsEvent() {
    let action = config.analytics.actions.promotionalGiveawayRegistration;
    if (this.configuration.gaActionPrefix) {
      action = this.configuration.gaActionPrefix + action;
    }
    let eventData = {
      event: config.analytics.events.gtmFormSubmission,
      category: config.analytics.categories.promotionalGiveaway,
      action,
      label: config.analytics.labels.submit
    };
    analytics.pushToEventFramework(eventData);
  }

};



// WEBPACK FOOTER //
// ./assets/components/PromotionalGiveaway/PromotionalGiveawayRegistration.js